import axios from '../axios-auth'

export const systemSerializeService = {
    getSystemSerializeList,
    saveSystemSerialize,
    getSystemSerializeDetail,
    getAllSystemSerializeType
};

function getAllSystemSerializeType() {
    return axios.get("/auth/system-serialize-types/");
}

function getSystemSerializeList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.prefix) {
        params["prefix"] = searchParams.prefix;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    return axios.get("/auth/system-serializes", { params });
}

function saveSystemSerialize(systemSerialize) {
    if (systemSerialize.id) {
        //edit
        return axios.put("/auth/system-serialize", systemSerialize);
    } else {
        // create new
        return axios.post("/auth/system-serialize", systemSerialize);
    }
}

function getSystemSerializeDetail(id) {
    return axios.get("/auth/system-serialize/" + id);
}